<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <div class="col d-column">
      <h1 class="title pt-2 pb-2">
        Wallet
        <span v-text="$ml.get('hereYouCanSetUpYourAccount')"
          >Aqui você pode configurar a sua conta para receber suas
          recompensas.</span
        >
      </h1>

      <div class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('addYourPayPalAccount')">
            Adicione sua conta do PayPal
          </h6>
        </div>

        <div class="card-body">
          <form v-on:submit.prevent="">
            <div class="row">
              <div class="col-24">
                <div class="form-group">
                  <label>PayPal Email</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="email"
                    :placeholder="$ml.get('pleaseMakeSureThatThisEmail')"
                    maxlength="100"
                  />
                  <transition name="fade">
                    <label
                      v-if="userError && !$v.email.required"
                      class="lblError"
                      v-text="$ml.get('enterYourPayPalAccountEmail')"
                      >Informe o email da conta PayPal</label
                    >
                    <label
                      v-if="userError && !$v.email.email"
                      class="lblError"
                      v-text="$ml.get('emailDoesNotAppearToBeValid')"
                      >O e-mail não parece ser válido</label
                    >
                  </transition>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-24">
                <div class="form-group">
                  <label v-text="$ml.get('informBugHuntPassword')"
                    >Informe a senha da plataforma BugHunt para confirmar esta
                    operação.
                  </label>
                  <input
                    type="password"
                    class="form-control"
                    v-model="password"
                    :placeholder="$ml.get('password')"
                    maxlength="200"
                  />
                  <transition name="fade">
                    <label
                      v-if="userError && !$v.password.required"
                      class="lblError"
                      v-text="$ml.get('enterYourUserPassword')"
                      >Informe sua senha de usuário</label
                    >
                    <label
                      v-if="userError && !$v.password.minLength"
                      class="lblError"
                      v-text="$ml.get('invalidPassword')"
                      >A senha deve ter de 6 a 50 caracteres</label
                    >
                  </transition>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center"> 
              <RecaptchaV2 ref="recaptcha" @verify="setRecaptchaToken" @expired="tokenRecaptcha = ''"  />
            </div>

            <div class="row pt-2">
              <button
                @click="alterPaypal"
                :disabled="!tokenRecaptcha"
                class="btn btnForm m-0"
                style="width: 166px;"
              >
                <Spinner v-show="loadingBtn" />
                <span v-show="!loadingBtn" v-text="$ml.get('saveEditions')"
                  >Salvar Alterações</span
                >
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import HackerService from "../../services/hacker.service";
import { required, minLength, email } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import RecaptchaV2 from "../../components/recaptchaV2.vue";

export default {
  components: {
    RecaptchaV2,
  },
  data() {
    return {
      password: "",
      email: "",
      userError: false,
      loadingBtn: false,
      tokenRecaptcha: "",
    };
  },
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(6) },
  },
  mounted() {
    this.email = this.$store.getters["getUser"].paypal_account;
  },
  methods: {
    setRecaptchaToken(token) {
      this.tokenRecaptcha = token
    },

    alterPaypal() {
      var self = this;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.userError = true;
        return;
      }
      this.userError = false;
      this.loadingBtn = true;

      HackerService.putPayPalAccount({
        password: this.password,
        paypal_account: this.email,
        tokenRecaptcha: this.tokenRecaptcha,
      }).then(
        () => {
          this.password = "";
          this.loadingBtn = false;

          this.$refs.recaptcha.resetRecaptcha();
          
          Swal.fire({
            icon: "success",
            title: self.$ml.get("dataChanged"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.setUser({
            paypal_account: this.email,
          });

          window.grecaptcha.reset();
          self.tokenRecaptcha = "";
        },
        () => {
          window.grecaptcha.reset();
          self.tokenRecaptcha = "";

          this.loadingBtn = false;
          
          Swal.fire({
            icon: "info",
            html: `<h4 class="mb-1">${self.$ml.get(
              "userDoesNotHavPermissionToPerform"
            )}</h4> 
              <label> 
              </label>  
              `,
            showConfirmButton: false,
            timer: 30000,
          });
        }
      );
    },
  },
};
</script>
